import {useItem} from '@adamlip/okeoke.client';
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3';
import {useEffect, useState} from 'react';

export default function CouponItem({sizeUUID, itemUUID, onItemChange}) {
	const {assembledItem} = useItem(itemUUID, sizeUUID);

	const [itemModalOpen, setItemModalOpen] = useState(false);

	const onCouponItemSelect = (assembledItem) => {
		onItemChange(itemUUID, assembledItem);
	};

	useEffect(() => {
		if (assembledItem) {
			onItemChange(itemUUID, assembledItem);
		}
		// eslint-disable-next-line
	}, [assembledItem]);

	return (
		<>
			<OrderItemModalV3 safeMode={true} isOpen={itemModalOpen} setIsOpen={setItemModalOpen} itemUUID={itemUUID} sizeUUID={sizeUUID} couponItem={true} onCouponItemSelect={onCouponItemSelect} />
			<div className='border-solid border-1 rounded-md p-2 ' onClick={() => setItemModalOpen(true)}>
				<div className='font-bold'>{assembledItem?.name?.hu}</div>
			</div>
		</>
	);
}
